module.exports = __webpack_public_path__ + "static/img/pic_wenjian@2x.fb26d275.png";